// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-size[data-v-00f033be]{max-height:46px}.icon-button[data-v-00f033be]{position:absolute;top:50%;transform:translateY(-50%);right:1.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
